import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",
    padding: 80,
    mobile: {
      desktop: { padding: 80 },
      smartphone: { padding: 20 },
    },
  },
  HEADLINE: {
    textAlign: "center",
    fontSize: "32pt",
    lineHeight: "40px",
    fontFamily: theme.fontFamily,
    // fontWeight: "bold" as "bold",
    paddingBottom: 10,
    mobile: {
      desktop: { fontSize: "32pt" },
      smartphone: { fontSize: "22pt", lineHeight: "32px" },
    },
  },
  TEXT: {
    textAlign: "center",
    fontFamily: theme.fontFamily,
    fontSize: "13pt",
    lineHeight: "18pt",
    padding: "20px 0",
  },
};
